<template>
    <!-- Main navigation container -->
    <header class="relative z-50 w-full h-24 bg-gray-50">
        <div
            class="container flex items-center justify-center h-full max-w-7xl px-8 mx-auto sm:justify-between xl:px-0">

            <a href="/" class="relative flex items-center inline-block h-5 h-full font-black leading-none">

                <svg class="w-auto h-6 text-orange-500 fill-current" xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 576 576">
                    <path
                        d="M309 106c11.4-7 19-19.7 19-34c0-22.1-17.9-40-40-40s-40 17.9-40 40c0 14.4 7.6 27 19 34L209.7 220.6c-9.1 18.2-32.7 23.4-48.6 10.7L72 160c5-6.7 8-15 8-24c0-22.1-17.9-40-40-40S0 113.9 0 136s17.9 40 40 40c.2 0 .5 0 .7 0L86.4 427.4c5.5 30.4 32 52.6 63 52.6H426.6c30.9 0 57.4-22.1 63-52.6L535.3 176c.2 0 .5 0 .7 0c22.1 0 40-17.9 40-40s-17.9-40-40-40s-40 17.9-40 40c0 9 3 17.3 8 24l-89.1 71.3c-15.9 12.7-39.5 7.5-48.6-10.7L309 106z" />
                </svg>

                <span class="ml-3 text-xl text-gray-800">Alfie<span class="text-orange-500"> Pet Supplies</span>.</span>
            </a>

            <nav id="nav" :class="{ 'hidden': !isMenuOpen }"
                class="absolute top-0 left-0 z-50 flex flex-col items-center justify-between w-full h-64 pt-5 mt-24 text-sm text-gray-700 bg-white border-t border-gray-200 md:w-auto md:flex-row md:h-24 lg:text-base md:bg-transparent md:mt-0 md:border-none md:py-0 md:flex md:relative">

                <router-link to="/"
                    class="ml-0 mr-0 font-bold duration-100 md:ml-12 md:mr-3 lg:mr-8 transition-color hover:text-gray-600">Home</router-link>

                <router-link to="/about"
                    class="mr-0 font-bold duration-100 md:mr-3 lg:mr-8 transition-color hover:text-gray-600">About</router-link>

                <router-link to="/store"
                    class="mr-0 font-bold duration-100 md:mr-3 lg:mr-8 transition-color hover:text-gray-600">Store</router-link>

                <router-link to="/adopt"
                    class="mr-0 font-bold duration-100 md:mr-3 lg:mr-8 transition-color hover:text-gray-600">Adopt</router-link>

                <router-link to="/contact"
                    class="mr-0 font-bold duration-100 md:mr-3 lg:mr-8 transition-color hover:text-gray-600">Contact
                    Us</router-link>

                <div class="relative flex flex-col items-center group">
                    <button @click="getRandomFact"
                        class="mr-0 font-bold duration-100 md:mr-3 lg:mr-8 transition-color rounded-md text-orange-500 bg-slate-50 shadow-md border-2 border-slate-100  p-1 px-2 hover:text-orange-400">
                        Get Cat Fact
                    </button>
                    <span class="relative flex h-3 w-3 -top-9 start-10">
                        <span
                            class="animate-ping absolute inline-flex h-full w-full rounded-full bg-orange-400 opacity-75"></span>
                        <span class="relative inline-flex rounded-full h-3 w-3 bg-orange-500"></span>
                    </span>
                </div>


                <div v-if="user.loggedIn"
                    class="flex flex-col block w-full font-medium border-t border-gray-200 md:hidden">

                    <!-- <div>Welcome, {{ user.displayName }}</div> -->
                    <button @click.prevent="signOut" @mouseover="hovered = true" @mouseout="hovered = false"
                        class="w-full py-2 font-bold text-center text-orange-500 flex justify-center gap-4 hover:bg-orange-500 hover:text-white duration-150">
                        Log Out
                        <span v-if="!hovered">
                            <svg class="h-5 fill-current text-orange-500" xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 512 512">
                                <path
                                    d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM176.4 176a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm128 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM160 336H352c8.8 0 16 7.2 16 16s-7.2 16-16 16H160c-8.8 0-16-7.2-16-16s7.2-16 16-16z" />
                            </svg>
                        </span>
                        <span v-else>
                            <svg class="h-5 fill-current text-gray-50" xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 512 512">
                                <path
                                    d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM159.3 388.7c-2.6 8.4-11.6 13.2-20 10.5s-13.2-11.6-10.5-20C145.2 326.1 196.3 288 256 288s110.8 38.1 127.3 91.3c2.6 8.4-2.1 17.4-10.5 20s-17.4-2.1-20-10.5C340.5 349.4 302.1 320 256 320s-84.5 29.4-96.7 68.7zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z" />
                            </svg>
                        </span></button>
                    <a href="../assets/pdf/voucher.pdf" download>
                        <button
                            class="w-full py-2 font-bold text-center text-orange-500 flex justify-center gap-3 duration-150">

                            Voucher
                            <svg class="h-5 fill-current text-orange-500" xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 512 512">
                                <path
                                    d="M256 0a256 256 0 1 0 0 512A256 256 0 1 0 256 0zM376.9 294.6L269.8 394.5c-3.8 3.5-8.7 5.5-13.8 5.5s-10.1-2-13.8-5.5L135.1 294.6c-4.5-4.2-7.1-10.1-7.1-16.3c0-12.3 10-22.3 22.3-22.3l57.7 0 0-96c0-17.7 14.3-32 32-32l32 0c17.7 0 32 14.3 32 32l0 96 57.7 0c12.3 0 22.3 10 22.3 22.3c0 6.2-2.6 12.1-7.1 16.3z" />
                            </svg>
                        </button>
                    </a>
                </div>
                <div v-else class="flex flex-col block w-full font-medium border-t border-gray-200 md:hidden">

                    <router-link to="/login"
                        class="w-full py-2 font-bold text-center text-orange-500">Login</router-link>
                    <router-link to="/register"
                        class="relative inline-block w-full px-5 py-3 text-sm leading-none text-center text-white border border-orange-500 bg-orange-500 fold-bold">Register</router-link>
                </div>
            </nav>

            <div
                class="absolute left-0 flex-col items-center justify-center hidden w-full pb-8 mt-48 border-b border-gray-200 md:relative md:w-auto md:bg-transparent md:border-none md:mt-0 md:flex-row md:p-0 md:items-end md:flex md:justify-between">

                <div v-if="user.loggedIn"
                    class="absolute left-0 flex-col items-center justify-center hidden w-full pb-8 mt-48 border-b border-gray-200 md:relative md:w-auto md:bg-transparent md:border-none md:mt-0 md:flex-row md:p-0 md:items-end md:flex md:justify-between">

                    <!-- <div>Welcome, {{ user.data.email }}</div> -->
                    <button @click.prevent="signOut" @mouseover="hovered = true" @mouseout="hovered = false"
                        class="relative z-40 px-3 py-2 mr-0 text-sm font-bold border border-orange-500 rounded text-orange-500 md:px-5 hover:bg-orange-500 hover:text-white duration-150 lg:text-dark sm:mr-3 md:mt-0 flex gap-4">
                        Log Out
                        <span v-if="!hovered">
                            <svg class="h-5 fill-current" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                                <path
                                    d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM176.4 176a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm128 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM160 336H352c8.8 0 16 7.2 16 16s-7.2 16-16 16H160c-8.8 0-16-7.2-16-16s7.2-16 16-16z" />
                            </svg>
                        </span>
                        <span v-else>
                            <svg class="h-5 fill-current" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                                <path
                                    d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM159.3 388.7c-2.6 8.4-11.6 13.2-20 10.5s-13.2-11.6-10.5-20C145.2 326.1 196.3 288 256 288s110.8 38.1 127.3 91.3c2.6 8.4-2.1 17.4-10.5 20s-17.4-2.1-20-10.5C340.5 349.4 302.1 320 256 320s-84.5 29.4-96.7 68.7zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z" />
                            </svg>
                        </span>
                    </button>


                    <button @click="showVoucher"
                        class="relative z-40 px-3 py-2 mr-0 text-sm font-bold border border-orange-500 rounded bg-orange-500 text-gray-50 md:px-5 lg:text-dark sm:mr-3 md:mt-0 flex gap-4">

                        Voucher <svg class=" h-5 fill-current text-gray-50" xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 512 512">
                            <path
                                d="M256 0a256 256 0 1 0 0 512A256 256 0 1 0 256 0zM376.9 294.6L269.8 394.5c-3.8 3.5-8.7 5.5-13.8 5.5s-10.1-2-13.8-5.5L135.1 294.6c-4.5-4.2-7.1-10.1-7.1-16.3c0-12.3 10-22.3 22.3-22.3l57.7 0 0-96c0-17.7 14.3-32 32-32l32 0c17.7 0 32 14.3 32 32l0 96 57.7 0c12.3 0 22.3 10 22.3 22.3c0 6.2-2.6 12.1-7.1 16.3z" />
                        </svg>
                    </button>
                </div>
                <div v-else
                    class="absolute left-0 flex-col items-center justify-center hidden w-full pb-8 mt-48 border-b border-gray-200 md:relative md:w-auto md:bg-transparent md:border-none md:mt-0 md:flex-row md:p-0 md:items-end md:flex md:justify-between">
                    <router-link to="/login"
                        class="relative z-40 px-3 py-2 mr-0 text-sm font-bold border border-orange-500 rounded text-orange-500 md:px-5 hover:bg-orange-500 hover:text-white duration-150 lg:text-dark sm:mr-3 md:mt-0">Login</router-link>
                    <router-link to="/register"
                        class="relative z-40 inline-block w-auto h-full px-5 py-3 text-sm font-bold leading-none text-white transition-all transition duration-100 duration-300 bg-orange-500 rounded shadow-md fold-bold lg:bg-orange lg:text-white-500 sm:w-full lg:shadow-none hover:shadow-xl bg-orange-500">Register</router-link>
                </div>
            </div>

            <div id="nav-mobile-btn" @click="toggleMenu"
                class="absolute top-0 right-0 z-50 block w-6 mt-8 mr-10 cursor-pointer select-none md:hidden sm:mt-10">
                <span class="block w-full h-1 mt-2 duration-200 transform bg-gray-800 rounded-full sm:mt-1"></span>
                <span class="block w-full h-1 mt-1 duration-200 transform bg-gray-800 rounded-full"></span>
            </div>

        </div>

        <!-- Cat Fact Modal -->
        <ConfirmationModal ref="catFactModal" class="flex justify-center">
            <p class="max-w-2xl px-5 mt-2 text-3xl leading-tight text-center sm:mt-0 sm:px-0 sm:text-xl font-semibold">
                {{ fact }}</p>
        </ConfirmationModal>

        <ConfirmationModal ref="voucherModal" class="flex justify-center">
            <h2><span class="font-bold">Discount Voucher!!!</span> - {{ user.data.email }}</h2>
            <img src="../assets/img/P.png" alt="">
        </ConfirmationModal>
    </header>
</template>

<script>
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import { computed } from "vue";
import { auth } from '@/firebaseConfig'

import ConfirmationModal from '@/components/contact/ConfirmationModal.vue';

export default {
    name: 'HeaderComponent',
    components: {
        ConfirmationModal
    },
    data() {
        return {
            isMenuOpen: false,
            hovered: false,
            fact: '',
        };
    },
    methods: {
        toggleMenu() {
            this.isMenuOpen = !this.isMenuOpen;
        },
        showVoucher() {
            this.$refs.voucherModal.open();
        },
        async getRandomFact() {
            try {
                const response = await fetch('https://catfact.ninja/fact');
                const data = await response.json();
                this.fact = data.fact;

                // Show the confirmation modal
                this.$refs.catFactModal.open();
            } catch (error) {
                console.error('Error fetching cat facts:', error);
            }
        },
    },
    setup() {

        const store = useStore()
        const router = useRouter()

        auth.onAuthStateChanged(user => {
            // User is logged in
            console.log("User Data:", user); // Check if user data is correctly retrieved
            store.dispatch("fetchUser", user);
        });

        const user = computed(() => store.getters.user);

        const signOut = async () => {
            await store.dispatch('logOut')
            router.push('/')
        }


        return { user, signOut }
    },
}
</script>

<style scoped>
button span {
    transition: opacity 0.3s ease;
    /* Add other desired transitions */
}

button:hover span:first-child {
    opacity: 0;
}

button:hover span:last-child {
    opacity: 1;
}

nav {
    /* padding: 30px; */

    a {
        /* font-weight: bold;
    color: #2c3e50; */

        &.router-link-exact-active {
            color: #f97316;
        }
    }
}
</style>